<template>
  <a-card :bordered="false">
    <a-row :gutter="24">
      <a-col :span="24">
        <!-- 条件搜索区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="[16, 8]">
              <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                <a-form-item label="类型">
                  <a-select
                    v-model:value="queryParam.type"
                    placeholder="请选择"
                    allow-clear
                    style="width: 100%"
                    class="no-border-radius-select"
                  >
                    <a-select-option v-for="dict in dict.type['complaint_type']" :key="dict.value" :value="dict.value">
                      {{ dict.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                <a-form-item label="状态">
                  <a-select
                    v-model:value="queryParam.complaintStatus"
                    placeholder="请选择"
                    allow-clear
                    style="width: 100%"
                    class="no-border-radius-select"
                  >
                    <a-select-option
                      v-for="dict in dict.type['complaint_status']"
                      :key="dict.value"
                      :value="dict.value"
                    >
                      {{ dict.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                <a-form-item label="发起源">
                  <a-select
                    v-model:value="queryParam.fromType"
                    placeholder="请选择"
                    allow-clear
                    style="width: 100%"
                    class="no-border-radius-select"
                  >
                    <a-select-option v-for="dict in dict.type['originator']" :key="dict.value" :value="dict.value">
                      {{ dict.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <!-- 按钮区域：默认在第一行，展开后在最后一行 -->
              <a-col v-if="!advanced" :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24" class="search-actions-col">
                <a-form-item>
                  <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                    <a-button type="primary" @click="handleQuery" class="search-button">搜索</a-button>
                    <span class="search-actions-group">
                      <a-button @click="resetQuery" class="no-border-button">重置</a-button>
                      <a-button @click="toggleAdvanced" class="no-border-button toggle-button">
                        {{ advanced ? '收起' : '展开' }}
                        <UpOutlined v-if="advanced" />
                        <DownOutlined v-else />
                      </a-button>
                    </span>
                  </span>
                </a-form-item>
              </a-col>

              <template v-if="advanced">
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="发起人">
                    <a-input
                      v-model:value="queryParam.userName"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="问题描述">
                    <a-input
                      v-model:value="queryParam.description"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="所在空间">
                    <a-input
                      v-model:value="queryParam.spaceName"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="负责员工">
                    <a-input
                      v-model:value="queryParam.employeeName"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="空间主管">
                    <a-input
                      v-model:value="queryParam.supervisorName"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="响应员工">
                    <a-input
                      v-model:value="queryParam.responseName"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="响应时间">
                    <a-date-picker
                      style="width: 100%"
                      v-model:value="queryParam.responseTime"
                      format="YYYY-MM-DD HH:mm:ss"
                      valueFormat="YYYY-MM-DD HH:mm:ss"
                      :show-time="{ format: 'HH:mm:ss' }"
                      placeholder="请选择"
                      allow-clear
                      class="no-border-radius-picker"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="确认员工">
                    <a-input
                      v-model:value="queryParam.confirmName"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="确认时间">
                    <a-date-picker
                      style="width: 100%"
                      v-model:value="queryParam.confirmTime"
                      format="YYYY-MM-DD HH:mm:ss"
                      valueFormat="YYYY-MM-DD HH:mm:ss"
                      :show-time="{ format: 'HH:mm:ss' }"
                      placeholder="请选择"
                      allow-clear
                      class="no-border-radius-picker"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="关闭员工">
                    <a-input
                      v-model:value="queryParam.closingName"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="关闭时间">
                    <a-date-picker
                      style="width: 100%"
                      v-model:value="queryParam.closingTime"
                      format="YYYY-MM-DD HH:mm:ss"
                      valueFormat="YYYY-MM-DD HH:mm:ss"
                      :show-time="{ format: 'HH:mm:ss' }"
                      placeholder="请选择"
                      allow-clear
                      class="no-border-radius-picker"
                    />
                  </a-form-item>
                </a-col>

                <!-- 展开后，按钮在最后一行 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24" class="search-actions-col">
                  <a-form-item>
                    <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                      <a-button type="primary" @click="handleQuery" class="search-button">搜索</a-button>
                      <span class="search-actions-group">
                        <a-button @click="resetQuery" class="no-border-button">重置</a-button>
                        <a-button @click="toggleAdvanced" class="no-border-button toggle-button">
                          {{ advanced ? '收起' : '展开' }}
                          <UpOutlined v-if="advanced" />
                          <DownOutlined v-else />
                        </a-button>
                      </span>
                    </span>
                  </a-form-item>
                </a-col>
              </template>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operations">
          <a-button
            type="text"
            shape="circle"
            @click="getList"
            v-hasPermi="['system:complaintOrder:refresh']"
            class="refresh-icon-button"
          >
            <img src="@/assets/images/projectUser/refresh.png" alt="刷新" />
          </a-button>
          <a-button type="primary" @click="handleAdd" v-hasPermi="['system:complaintOrder:add']" class="add-button">
            <PlusOutlined />新增
          </a-button>
          <a-button
            @click="handleExport"
            v-hasPermi="['system:complaintOrder:export']"
            class="no-border-button import-export-button"
          >
            <UploadOutlined />导出
          </a-button>
          <a-button
            @click="handleImport"
            v-hasPermi="['system:complaintOrder:import']"
            class="no-border-button import-export-button"
          >
            <DownloadOutlined />导入
          </a-button>

          <a-button
            :disabled="multiple"
            @click="handleDelete"
            v-hasPermi="['system:complaintOrder:remove']"
            class="no-border-button delete-button"
          >
            <DeleteOutlined />删除
          </a-button>
          <a-button
            @click="handleDownloadTemplate"
            v-hasPermi="['system:complaintOrder:importTemplate']"
            class="no-border-button template-download-button"
          >
            <CloudDownloadOutlined />导入模板下载
          </a-button>
          <!-- <table-setting
            :style="{ float: 'right' }"
            v-model:table-size="tableSize"
            v-model:value="columns"
            :refresh-loading="loading"
            @refresh="getList"
          /> -->
        </div>
        <!-- 组件 -->
        <import-excel ref="importExcel" @ok="getList" />
        <create-form ref="createForm" @ok="getList" @close="getList" />
        <FormDetail ref="formDetail" />
        <ComplaintHandleLog
          :visible="handleLogVisible"
          :complaint-id="currentComplaintId"
          @close="handleHandleLogClose"
        />
        <a-modal
          title="照片预览"
          :visible="photoPreviewVisible"
          :footer="null"
          width="60%"
          @cancel="handlePhotoPreviewClose"
        >
          <div v-if="photoPreviewList.length" class="photo-preview-container">
            <div class="photo-preview-carousel-wrapper">
              <a-button
                v-if="photoPreviewList.length > 1"
                class="photo-preview-nav-button prev-button"
                :disabled="photoPreviewIndex === 0"
                @click="handlePhotoPrev"
              >
                <LeftOutlined />
              </a-button>
              <a-carousel
                ref="photoCarouselRef"
                :dots="photoPreviewList.length > 1"
                :autoplay="false"
                :before-change="handlePhotoCarouselChange"
              >
                <div v-for="url in photoPreviewList" :key="url" class="photo-preview-slide">
                  <img :src="url" alt="照片" @click="openPhotoInNewTab(url)" />
                  <a-button type="link" block @click="openPhotoInNewTab(url)"> 在新窗口打开 </a-button>
                </div>
              </a-carousel>
              <a-button
                v-if="photoPreviewList.length > 1"
                class="photo-preview-nav-button next-button"
                :disabled="photoPreviewIndex === photoPreviewList.length - 1"
                @click="handlePhotoNext"
              >
                <RightOutlined />
              </a-button>
            </div>
            <div v-if="photoPreviewList.length > 1" class="photo-preview-counter">
              共 {{ photoPreviewList.length }} 张，当前第 {{ photoPreviewIndex + 1 }} 张
            </div>
          </div>
          <a-empty v-else description="未找到照片" />
        </a-modal>
        <!-- 数据表格 -->
        <div style="margin-top: 20px">
          <a-table
            :loading="loading"
            :size="tableSize"
            rowKey="id"
            :columns="tableColumns"
            :data-source="list"
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange,
              fixed: true,
            }"
            :pagination="false"
            :bordered="tableBordered"
            :scroll="{ x: 2000 }"
            class="optimized-table"
          >
            <!-- 使用 bodyCell 插槽自定义单元格显示 -->
            <template #bodyCell="{ column, text, record, index }">
              <!-- 序号列 -->
              <template v-if="column.dataIndex === 'index'">
                <span>{{
                  (queryParam.pageNum - 1) * queryParam.pageSize +
                  (index !== undefined && index !== null ? index : list.findIndex((item) => item.id === record.id)) +
                  1
                }}</span>
              </template>
              <!-- 类型：使用字典标签显示 -->
              <template v-if="column.dataIndex === 'type'">
                <span>
                  <dict-tag :options="dict.type['complaint_type']" :value="record.type" />
                </span>
              </template>
              <!-- 状态：使用字典标签显示 -->
              <template v-else-if="column.dataIndex === 'complaintStatus'">
                <span>
                  <dict-tag :options="dict.type['complaint_status']" :value="record.complaintStatus" />
                </span>
              </template>
              <!-- 发起源：显示文字 -->
              <template v-else-if="column.dataIndex === 'fromType'">
                <span>
                  <dict-tag :options="dict.type['originator']" :value="record.fromType" />
                </span>
              </template>
              <!-- 响应时间 -->
              <template v-else-if="column.dataIndex === 'responseTime'">
                <span>
                  {{ parseTime(record.responseTime) }}
                </span>
              </template>
              <!-- 确认时间 -->
              <template v-else-if="column.dataIndex === 'confirmTime'">
                <span>
                  {{ parseTime(record.confirmTime) }}
                </span>
              </template>
              <!-- 关闭时间 -->
              <template v-else-if="column.dataIndex === 'closingTime'">
                <span>
                  {{ parseTime(record.closingTime) }}
                </span>
              </template>
              <!-- 创建时间 -->
              <template v-else-if="column.dataIndex === 'createTime'">
                <span>
                  {{ parseTime(record.createTime) }}
                </span>
              </template>
              <!-- 操作列 -->
              <template v-else-if="column.dataIndex === 'operation'">
                <div class="table-action-buttons">
                  <a
                    @click="$refs['formDetail'].handleUpdate(record, undefined)"
                    v-hasPermi="['system:complaintOrder:orderDetail']"
                    class="edit-link"
                  >
                    工单详情
                  </a>
                  <span v-if="hasPhotos(record)" class="action-divider">|</span>
                  <a
                    v-if="hasPhotos(record)"
                    @click="handleViewPhotos(record)"
                    v-hasPermi="['system:complaintOrder:viewPhotos']"
                    class="photo-link"
                  >
                    查看照片
                  </a>
                  <span v-if="showCloseAction(record)" class="action-divider">|</span>
                  <a
                    v-if="showCloseAction(record)"
                    @click="handleCloseOrder(record)"
                    v-hasPermi="['system:complaintOrder:closedWorkOrder']"
                    class="close-order-link"
                  >
                    完结工单
                  </a>
                  <span v-if="showCloseAction(record)" class="action-divider">|</span>
                  <a
                    v-if="showCloseAction(record)"
                    @click="handleShowHandleLog(record)"
                    v-hasPermi="['system:complaintOrder:processingRecord']"
                    class="handle-log-link"
                  >
                    处理记录
                  </a>
                </div>
              </template>
              <!-- 其他字段：默认显示 text 值 -->
              <template v-else>
                <span>{{ text }}</span>
              </template>
            </template>
          </a-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-wrapper">
          <div class="pagination-left">
            <span class="pagination-info">
              显示第 {{ (queryParam.pageNum - 1) * queryParam.pageSize + 1 }} 到第
              {{ Math.min(queryParam.pageNum * queryParam.pageSize, total) }} 条数据/共 {{ total }} 条
            </span>
            <a-select
              v-model:value="queryParam.pageSize"
              style="width: 100px; margin-left: 8px"
              @change="onShowSizeChange(queryParam.pageNum, queryParam.pageSize)"
              class="no-border-radius-select"
            >
              <a-select-option :value="10">10条/页</a-select-option>
              <a-select-option :value="20">20条/页</a-select-option>
              <a-select-option :value="50">50条/页</a-select-option>
              <a-select-option :value="100">100条/页</a-select-option>
            </a-select>
          </div>
          <div class="pagination-right">
            <a-pagination
              :current="queryParam.pageNum"
              :total="total"
              :page-size="queryParam.pageSize"
              :show-total="() => ''"
              @change="changeSize"
            />
            <span class="pagination-jump">
              到第
              <a-input-number
                v-model:value="jumpPage"
                :min="1"
                :max="Math.ceil(total / queryParam.pageSize)"
                style="width: 60px; margin: 0 4px"
                @pressEnter="handleJumpPage"
                class="no-border-radius-input-number"
              />
              页
            </span>
          </div>
        </div>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../utils/gogocodeTransfer'
import {
  SearchOutlined,
  RedoOutlined,
  UpOutlined,
  DownOutlined,
  PlusOutlined,
  DeleteOutlined,
  DownloadOutlined,
  UploadOutlined,
  CloudDownloadOutlined,
  LeftOutlined,
  RightOutlined,
} from '@ant-design/icons-vue'
import {
  pageComplaintOrder,
  listComplaintOrder,
  delComplaintOrder,
  changeComplaintOrderStatus,
  closeComplaintOrder,
} from '@/api/system/complaintOrder'
import CreateForm from './modules/CreateForm'
import FormDetail from './modules/FormDetail'
import ImportExcel from './modules/ImportExcel'
import ComplaintHandleLog from './modules/ComplaintHandleLog'
import { tableMixin } from '@/store/table-mixin'

/**
 * 投诉工单列表页
 * - 按项目和表格字段筛选
 * - 支持导入导出、快速刷新
 */
export default {
  name: 'ComplaintOrder',
  dicts: ['complaint_type', 'originator', 'complaint_status'],
  components: {
    SearchOutlined,
    RedoOutlined,
    UpOutlined,
    DownOutlined,
    PlusOutlined,
    DeleteOutlined,
    DownloadOutlined,
    UploadOutlined,
    CloudDownloadOutlined,
    LeftOutlined,
    RightOutlined,
    CreateForm,
    ImportExcel,
    FormDetail,
    ComplaintHandleLog,
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索展开/收起
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      photoPreviewVisible: false,
      photoPreviewList: [],
      photoPreviewIndex: 0,
      handleLogVisible: false,
      currentComplaintId: null,
      jumpPage: 1,
      // 查询参数
      queryParam: {
        projectId: undefined,
        type: undefined,
        complaintStatus: undefined,
        fromType: undefined,
        userName: undefined,
        description: undefined,
        spaceName: undefined,
        employeeName: undefined,
        supervisorName: undefined,
        responseName: undefined,
        responseTime: undefined,
        confirmName: undefined,
        confirmTime: undefined,
        closingName: undefined,
        closingTime: undefined,
        pageNum: 1,
        pageSize: 10,
      },
      columns: [
        {
          title: '类型',
          dataIndex: 'type',
          ellipsis: true,
          align: 'center',
          width: 200,
        },
        {
          title: '状态',
          dataIndex: 'complaintStatus',
          ellipsis: true,
          align: 'center',
          width: 200,
        },

        {
          title: '发起源',
          dataIndex: 'fromType',
          ellipsis: true,
          align: 'center',
          width: 140,
        },
        {
          title: '发起人',
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center',
          width: 160,
        },
        {
          title: '问题描述',
          dataIndex: 'description',
          ellipsis: true,
          align: 'center',
          width: 240,
        },
        {
          title: '手机号',
          dataIndex: 'phone',
          ellipsis: true,
          align: 'center',
          width: 140,
        },
        {
          title: '工单提交时间',
          dataIndex: 'createTime',
          ellipsis: true,
          align: 'center',
          width: 180,
        },
        {
          title: '所在空间',
          dataIndex: 'spaceName',
          ellipsis: true,
          align: 'center',
          width: 160,
        },
        {
          title: '空间负责员工',
          dataIndex: 'employeeName',
          ellipsis: true,
          align: 'center',
          width: 180,
        },
        {
          title: '空间主管',
          dataIndex: 'supervisorName',
          ellipsis: true,
          align: 'center',
          width: 180,
        },
        {
          title: '响应员工',
          dataIndex: 'responseName',
          ellipsis: true,
          align: 'center',
          width: 160,
        },
        {
          title: '响应时间',
          dataIndex: 'responseTime',
          ellipsis: true,
          align: 'center',
          width: 180,
        },
        {
          title: '确认员工',
          dataIndex: 'confirmName',
          ellipsis: true,
          align: 'center',
          width: 180,
        },
        {
          title: '确认时间',
          dataIndex: 'confirmTime',
          ellipsis: true,
          align: 'center',
          width: 180,
        },
        // {
        //   title: '照片URL',
        //   dataIndex: 'url',
        //   ellipsis: true,
        //   align: 'center',
        //   width: 200
        // },

        // {
        //   title: '响应员工ID,关联{sys_user.id}',
        //   dataIndex: 'responseId',
        //   ellipsis: true,
        //   align: 'center',
        //   width: 180
        // },

        {
          title: '关闭员工',
          dataIndex: 'closingName',
          ellipsis: true,
          align: 'center',
          width: 180,
        },
        {
          title: '关闭时间',
          dataIndex: 'closingTime',
          ellipsis: true,
          align: 'center',
          width: 180,
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 400,
          align: 'center',
          fixed: 'right',
        },
      ],
    }
  },
  created() {
    const currentProjectId = this.$store.getters.currentProjectId
    if (currentProjectId) {
      this.queryParam.projectId = currentProjectId
    }
    this.getList()
    $on(this.$root, 'project-changed', this.handleProjectChanged)
  },
  beforeUnmount() {
    $off(this.$root, 'project-changed', this.handleProjectChanged)
  },
  computed: {
    submitButtonStyle() {
      return {}
    },
    // 表格列配置（使用 computed 以便在 customRender 中访问 this）
    tableColumns() {
      const that = this
      return [
        {
          title: '序号',
          dataIndex: 'index',
          align: 'center',
          width: 80,
          customRender: ({ index }) => {
            const { pageNum, pageSize } = that.queryParam
            return (pageNum - 1) * pageSize + index + 1
          },
        },
        ...this.columns, // 保留其他列配置
      ]
    },
  },
  methods: {
    /** 查询投诉工单列表 */
    getList() {
      const currentProjectId = this.$store.getters.currentProjectId
      if (currentProjectId) {
        this.queryParam.projectId = currentProjectId
      }
      this.loading = true
      pageComplaintOrder(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.jumpPage = this.queryParam.pageNum
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /**
     * 新增前校验项目
     */
    handleAdd() {
      if (!this.$store.getters.currentProjectId) {
        this.$message.warning('请先选择项目', 3)
        return
      }
      this.$refs.createForm.handleAdd()
    },
    /**
     * 导入前校验项目
     */
    handleImport() {
      if (!this.$store.getters.currentProjectId) {
        this.$message.warning('请先选择项目', 3)
        return
      }
      this.$refs.importExcel.importExcelHandleOpen()
    },
    /** 重置按钮操作 */
    resetQuery() {
      const currentProjectId = this.$store.getters.currentProjectId
      this.queryParam = {
        projectId: currentProjectId || undefined,
        type: undefined,
        complaintStatus: undefined,
        fromType: undefined,
        userName: undefined,
        description: undefined,
        spaceName: undefined,
        employeeName: undefined,
        supervisorName: undefined,
        responseName: undefined,
        responseTime: undefined,
        confirmName: undefined,
        confirmTime: undefined,
        closingName: undefined,
        closingTime: undefined,
        pageNum: 1,
        pageSize: 10,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.queryParam.pageNum = 1
      this.jumpPage = 1
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.jumpPage = current
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /**
     * 控制“完结工单”按钮显示
     * 仅当类型为“投诉”或“巡检单”时展示
     * @param {Object} record 行数据
     * @returns {Boolean}
     */
    showCloseAction(record) {
      if (!record || !record.type) {
        return false
      }
      const typeDict = (this.dict && this.dict.type && this.dict.type['complaint_type']) || []
      const target = typeDict.find((item) => item.value === record.type)
      const label = target ? target.label : record.type
      const closableLabels = ['投诉', '巡检单']
      return closableLabels.includes(label)
    },
    /**
     * 判断是否有照片
     * @param {Object} record - 行数据对象
     * @returns {Boolean}
     */
    hasPhotos(record) {
      if (!record || !record.url) {
        return false
      }
      const urls = record.url
        .split(',')
        .map((item) => item.trim())
        .filter((item) => item)
      return urls.length > 0
    },
    /**
     * 查看多图照片
     * @param {Object} record
     */
    handleViewPhotos(record) {
      const urls = ((record && record.url) || '')
        .split(',')
        .map((item) => item.trim())
        .filter((item) => item)
      if (!urls.length) {
        this.$message.warning('该工单暂无照片', 3)
        return
      }
      this.photoPreviewList = urls
      this.photoPreviewIndex = 0
      this.photoPreviewVisible = true
    },
    /**
     * 上一张照片
     */
    handlePhotoPrev() {
      if (this.photoPreviewIndex > 0) {
        this.photoPreviewIndex--
        this.$refs.photoCarouselRef?.prev()
      }
    },
    /**
     * 下一张照片
     */
    handlePhotoNext() {
      if (this.photoPreviewIndex < this.photoPreviewList.length - 1) {
        this.photoPreviewIndex++
        this.$refs.photoCarouselRef?.next()
      }
    },
    /**
     * 轮播切换回调
     */
    handlePhotoCarouselChange(from, to) {
      this.photoPreviewIndex = to
    },
    /**
     * 关闭照片预览
     */
    handlePhotoPreviewClose() {
      this.photoPreviewVisible = false
      this.photoPreviewList = []
      this.photoPreviewIndex = 0
    },
    /**
     * 新窗口打开照片
     * @param {String} url
     */
    openPhotoInNewTab(url) {
      window.open(url, '_blank')
    },
    /**
     * 显示处理记录弹窗
     * @param {Object} record - 行数据对象
     */
    handleShowHandleLog(record) {
      if (!record || !record.id) {
        this.$message.warning('工单ID不能为空', 3)
        return
      }
      this.currentComplaintId = record.id
      this.handleLogVisible = true
    },
    /**
     * 关闭处理记录弹窗
     */
    handleHandleLogClose() {
      this.handleLogVisible = false
      this.currentComplaintId = null
    },
    handleProjectChanged(projectId) {
      this.queryParam.projectId = projectId || undefined
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      // 判断 row 是否是行数据对象（有 id 属性且不是事件对象）
      const isRowData = row && typeof row === 'object' && 'id' in row && !('target' in row) && !('currentTarget' in row)

      const ids = isRowData ? row.id : this.ids
      if (isRowData && row.id) {
        if (!this.ids.includes(row.id)) {
          this.ids.push(row.id)
        }
      }

      // 获取要删除的类型名称
      let typeText = ''
      const typeDict = (this.dict && this.dict.type && this.dict.type['complaint_type']) || []

      if (isRowData && row.type !== undefined && row.type !== null) {
        // 单行删除，显示该行的类型名称
        const typeItem = typeDict.find((item) => {
          return String(item.value) === String(row.type) || item.value == row.type
        })
        typeText = typeItem ? typeItem.label : row.type || ''
      } else if (this.selectedRows && this.selectedRows.length > 0) {
        // 多行删除，显示所有选中行的类型名称
        const types = this.selectedRows
          .map((item) => {
            if (item && item.type !== undefined && item.type !== null) {
              const typeItem = typeDict.find((dictItem) => {
                return String(dictItem.value) === String(item.type) || dictItem.value == item.type
              })
              return typeItem ? typeItem.label : item.type || ''
            }
            return null
          })
          .filter((type) => type && type !== '')
        typeText = types.length > 0 ? types.join('、') : ''
      }

      this.$confirm({
        title: '确认删除所选中数据?',
        content: typeText ? `类型为：${typeText}` : '确认删除所选数据?',
        onOk() {
          let data = []
          that.ids.map((id) => data.push({ id: id }))
          return delComplaintOrder(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        },
      })
    },
    /**
     * 完结工单操作
     * @param {Object} record - 行数据对象
     */
    handleCloseOrder(record) {
      const that = this
      this.$confirm({
        title: '确认完结工单吗?',
        content: '确认要完结该工单吗？',
        onOk() {
          return closeComplaintOrder({ id: record.id })
            .then(() => {
              that.getList()
              that.$message.success('完结工单成功', 3)
            })
            .catch(() => {
              that.$message.error('完结工单失败', 3)
            })
        },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      const params = { ...this.queryParam }
      const hasSelection = this.selectedRowKeys && this.selectedRowKeys.length > 0
      if (hasSelection) {
        params.complaintIds = this.selectedRowKeys
      }
      this.$confirm({
        title: '是否确认导出?',
        content: hasSelection ? '将导出所选数据' : '将导出当前筛选条件下的全部数据',
        onOk: () => {
          this.download('system/complaint-order/export', params, `投诉工单_${new Date().getTime()}.xls`)
        },
      })
    },

    /**
     * 下载导入模板
     */
    handleDownloadTemplate() {
      this.download('system/complaint-order/importTemplate', {}, `投诉工单导入模板_${new Date().getTime()}.xls`)
    },
    /** 启用 */
    handleEnable() {
      this.handleChangeStatus(1)
    },
    /** 禁用 */
    handleDisable() {
      this.handleChangeStatus(0)
    },
    handleChangeStatus(status) {
      if (!this.selectedRowKeys.length) {
        this.$message.warning('请先选择需要操作的数据')
        return
      }
      const actionText = status === 1 ? '启用' : '禁用'
      const ids = [...this.selectedRowKeys].join(',')
      this.$confirm({
        title: `确认${actionText}所选中数据?`,
        content: `当前选中编号为 ${ids} 的数据`,
        onOk: () => {
          const data = {
            ids,
            status: status,
          }
          return changeComplaintOrderStatus(data).then(() => {
            this.$message.success(`${actionText}成功`)
            this.onSelectChange([], [])
            this.getList()
          })
        },
      })
    },
    /** 跳转到指定页码 */
    handleJumpPage() {
      if (this.jumpPage && this.jumpPage >= 1) {
        const maxPage = Math.ceil(this.total / this.queryParam.pageSize)
        if (this.jumpPage > maxPage) {
          this.jumpPage = maxPage
        }
        this.queryParam.pageNum = this.jumpPage
        this.getList()
      }
    },
  },
}
</script>

<style scoped>
/* 条件搜索区域样式 */
.table-page-search-wrapper :deep(.ant-form-item-label) {
  width: 80px;
  min-width: 80px;
  flex: 0 0 80px !important;
  max-width: 80px !important;
}

.table-page-search-wrapper :deep(.ant-form-item-label > label) {
  width: 100%;
  text-align: right;
}

/* 搜索栏 FormItem 布局：左侧文字固定 80px，右侧输入区域自适应 */
.table-page-search-wrapper :deep(.ant-form-item) {
  width: 100%;
}

.table-page-search-wrapper :deep(.ant-form-item-row) {
  flex-wrap: nowrap;
}

.table-page-search-wrapper :deep(.ant-form-item-control) {
  flex: 1 1 0 !important;
  max-width: none !important;
  margin-left: 8px;
  min-width: 0;
}

.table-page-search-wrapper :deep(.ant-form-item-control-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input-content) {
  width: 100%;
  min-width: 0;
}

/* 移除所有输入框圆角的通用样式 */
.no-border-radius-input :deep(.ant-input) {
  border-radius: 0 !important;
}

.no-border-radius-input :deep(.ant-input-affix-wrapper) {
  border-radius: 0 !important;
}

.no-border-radius-picker :deep(.ant-picker) {
  border-radius: 0 !important;
}

.no-border-radius-select :deep(.ant-select-selector) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 搜索区域输入框样式覆盖 - 优先级高于 no-border-radius-input */
/* 普通输入框样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input) {
  width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 带前缀/后缀的输入框外层样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper) {
  width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input) {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 通用规则：当 input 在 affix-wrapper 内时，必须去掉边框避免嵌套 - 最高优先级 */
/* 覆盖所有边框相关属性 */
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input),
.no-border-radius-input :deep(.ant-input-affix-wrapper > .ant-input),
.no-border-radius-input :deep(.ant-input-affix-wrapper input.ant-input),
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input:hover),
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input:focus),
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input:not(:focus):not(:hover)) {
  border: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
  border-left: 0 !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}

/* 输入框内部的 input 元素 - 必须去掉边框避免嵌套 - 最高优先级 */
/* 使用更具体的选择器确保覆盖所有情况 */
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper > .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper > .ant-input),
.table-page-search-wrapper :deep(.ant-form-item .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input-content .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:hover),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input:hover),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper input.ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:not(:focus):not(:hover)),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input[type='text']) {
  border: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
  border-left: 0 !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  width: 100% !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}

/* 强制去掉所有在 affix-wrapper 内的 input 边框 - 使用最高优先级选择器 */
/* 覆盖所有可能的边框属性和状态 */
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper input.ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:not(:focus):not(:hover)),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:hover),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input[type='text']) {
  border: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
  border-left: 0 !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}

/* 移除搜索栏输入框、下拉选择框、日期选择框聚焦时的高亮效果 */
/* 输入框聚焦样式 - 普通input（未被affix-wrapper包裹）保持边框不变，去掉高亮 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input:focus:not(.ant-input-affix-wrapper .ant-input)),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-focused:not(.ant-input-affix-wrapper .ant-input)),
.table-page-search-wrapper :deep(.ant-input:focus:not(.ant-input-affix-wrapper .ant-input)),
.table-page-search-wrapper :deep(.ant-input-focused:not(.ant-input-affix-wrapper .ant-input)) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 带前缀/后缀的输入框聚焦样式 - 外部容器保持边框，内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 聚焦时，内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 日期选择器样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker),
.table-page-search-wrapper :deep(.ant-picker) {
  width: 100% !important;
  min-width: auto !important;
  max-width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 下拉选择框样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector) {
  width: 100% !important;
  min-width: auto !important;
  max-width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 下拉选择框容器样式 */
.table-page-search-wrapper :deep(.no-border-radius-select.ant-select),
.table-page-search-wrapper :deep(.ant-select) {
  width: 100% !important;
  min-width: auto !important;
  max-width: 100% !important;
}

/* 下拉选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector:focus),
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-focused .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector:focus),
.table-page-search-wrapper :deep(.ant-select-focused .ant-select-selector) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 日期选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker:focus),
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker-focused),
.table-page-search-wrapper :deep(.ant-picker:focus),
.table-page-search-wrapper :deep(.ant-picker-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

.table-page-search-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

/* 搜索按钮和新增按钮样式 */
.search-button,
.add-button {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.search-button:hover,
.add-button:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
}

.search-button:focus,
.add-button:focus {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 其他按钮圆角设置 */
.table-page-search-wrapper :deep(.ant-btn) {
  border-radius: 4px;
}

/* 按钮区域样式 */
.table-page-search-submitButtons {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.search-actions-col {
  display: flex;
  justify-content: flex-end;
}

.search-actions-group {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.table-operations :deep(.ant-btn) {
  border-radius: 4px;
}

/* 全局按钮圆角设置 */
:deep(.ant-btn) {
  border-radius: 4px !important;
}

.table-action-buttons a {
  color: #1890ff;
  cursor: pointer;
  white-space: nowrap; /* 防止操作按钮换行 */
}

.table-action-buttons a:hover {
  color: #40a9ff;
}

/* 编辑按钮颜色 */
.table-action-buttons .edit-link {
  color: #165dff !important;
}

.table-action-buttons .edit-link:hover {
  color: #4080ff !important;
}

/* 查看照片按钮颜色 */
.table-action-buttons .photo-link {
  color: #fe6634 !important;
}

.table-action-buttons .photo-link:hover {
  color: #ff8c66 !important;
}

/* 完结工单按钮颜色 */
.table-action-buttons .close-order-link {
  color: #35c66b !important;
}

.table-action-buttons .close-order-link:hover {
  color: #5dd88a !important;
}

/* 处理记录按钮颜色 */
.table-action-buttons .handle-log-link {
  color: #1eb3df !important;
}

.table-action-buttons .handle-log-link:hover {
  color: #4cc5e8 !important;
}

.action-divider {
  margin: 0 8px;
  color: #d9d9d9;
  white-space: nowrap;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

@media (max-width: 992px) {
  .table-page-search-wrapper :deep(.ant-form-item-row) {
    flex-wrap: wrap;
  }

  .table-page-search-wrapper :deep(.ant-form-item-label) {
    width: auto;
    min-width: 0;
    flex: 0 0 auto !important;
    max-width: none !important;
  }

  .table-page-search-wrapper :deep(.ant-form-item-label > label) {
    width: auto;
    text-align: left;
  }

  .table-page-search-wrapper :deep(.ant-form-item-control) {
    flex: 1 1 100% !important;
    max-width: none !important;
    margin-left: 0;
  }

  .search-actions-col {
    justify-content: flex-start;
  }
}

.table-operations {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.refresh-icon-button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-left {
  display: flex;
  align-items: center;
}

.pagination-info {
  color: rgba(0, 0, 0, 0.65);
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pagination-jump {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
}

/* 分页组件样式 - 去掉圆角 */
.pagination-wrapper :deep(.ant-btn) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-item) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev),
.pagination-wrapper :deep(.ant-pagination-next),
.pagination-wrapper :deep(.ant-pagination-prev .ant-pagination-item-link),
.pagination-wrapper :deep(.ant-pagination-next .ant-pagination-item-link) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev button),
.pagination-wrapper :deep(.ant-pagination-next button) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 分页选中页数样式 */
.pagination-wrapper :deep(.ant-pagination-item-active) {
  background: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active a) {
  color: #ffffff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover) {
  background: #165dff !important;
  border-color: #165dff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover a) {
  color: #ffffff !important;
}

/* 去掉指定按钮的边框 */
.no-border-button {
  border: none !important;
  background: #f3f3f3 !important;
  color: #101010 !important;
}

.no-border-button:hover,
.no-border-button:focus {
  border: none !important;
  background: #f3f3f3 !important;
  color: #101010 !important;
}

/* 展开/收起按钮文字和图标颜色，去掉底部阴影 */
.toggle-button {
  background: transparent !important;
  color: #165dff !important;
  box-shadow: none !important;
}

.toggle-button :deep(.anticon) {
  color: #165dff !important;
}

.toggle-button:hover,
.toggle-button:focus {
  background: transparent !important;
  color: #165dff !important;
  box-shadow: none !important;
}

.toggle-button:hover :deep(.anticon),
.toggle-button:focus :deep(.anticon) {
  color: #165dff !important;
}

/* 删除按钮样式 - 参照 projectUser 页面的修改状态按钮 */
.delete-button {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

.delete-button:hover,
.delete-button:focus {
  color: #333333 !important;
}

.delete-button:disabled {
  color: rgba(0, 0, 0, 0.25) !important;
}

/* 导入导出按钮背景颜色 */
.import-export-button {
  background: #f3f3f3 !important;
  color: #333 !important;
}

.import-export-button :deep(.anticon) {
  color: #333 !important;
}

.import-export-button:hover {
  background: #f3f3f3 !important;
  color: #333 !important;
}

.import-export-button:hover :deep(.anticon) {
  color: #333 !important;
}

.import-export-button:focus {
  background: #f3f3f3 !important;
  color: #333 !important;
}

.import-export-button:focus :deep(.anticon) {
  color: #333 !important;
}

/* 导入模板下载按钮文字和图标颜色，去掉底部阴影 */
.template-download-button {
  background: transparent !important;
  color: #165dff !important;
  box-shadow: none !important;
}

.template-download-button :deep(.anticon) {
  color: #165dff !important;
}

.template-download-button:hover,
.template-download-button:focus {
  background: transparent !important;
  color: #165dff !important;
  box-shadow: none !important;
}

.template-download-button:hover :deep(.anticon),
.template-download-button:focus :deep(.anticon) {
  color: #165dff !important;
}

/* 优化表格样式 */
.optimized-table :deep(.ant-table-thead > tr > th) {
  white-space: nowrap; /* 表头不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.optimized-table :deep(.ant-table-tbody > tr > td) {
  white-space: nowrap; /* 表格内容不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 12px 8px; /* 增加内边距 */
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 操作列固定右侧样式 */
.optimized-table :deep(.ant-table-tbody > tr > td:last-child) {
  position: sticky;
  right: 0;
  background: white;
  z-index: 10;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 选中行的操作列样式 */
.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected > td:last-child) {
  position: sticky;
  right: 0;
  background: white !important;
  z-index: 10;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td:last-child) {
  position: sticky;
  right: 0;
  background: #f5f5f5 !important;
  z-index: 10;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-thead > tr > th:last-child) {
  position: sticky;
  right: 0;
  background: #fafafa;
  z-index: 11;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 行悬停效果 */
.optimized-table :deep(.ant-table-tbody > tr:hover > td) {
  background-color: #f5f5f5;
}

/* 去掉表格边框 */
:deep(.ant-table) {
  border: none !important;
}

:deep(.ant-table-container) {
  border: none !important;
}

:deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-thead > tr > th:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-tbody > tr > td:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr:last-child > td) {
  border-bottom: none !important;
}

/* 表格滚动条样式优化 */
:deep(.ant-table-body) {
  overflow-x: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

:deep(.ant-table-body::-webkit-scrollbar) {
  height: 8px;
}

:deep(.ant-table-body::-webkit-scrollbar-track) {
  background: #f5f5f5;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb) {
  background: #d9d9d9;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb:hover) {
  background: #bfbfbf;
}

/* 序号列样式优化 */
:deep(.ant-table-tbody > tr > td:first-child) {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 选中的行样式 - 去掉背景色 */
:deep(.ant-table-tbody > tr.ant-table-row-selected > td) {
  background-color: transparent !important;
}

:deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td) {
  background-color: transparent !important;
}

/* 表格复选框样式 */
.optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 0 !important;
  border-color: #999999 !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #ffffff !important;
}

.optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 表格复选框列固定左侧样式 */
.optimized-table :deep(.ant-table-thead > tr > th:first-child) {
  position: sticky;
  left: 0;
  background: #fafafa;
  z-index: 12;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr > td:first-child) {
  position: sticky;
  left: 0;
  background: white;
  z-index: 11;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected > td:first-child) {
  position: sticky;
  left: 0;
  background: white !important;
  z-index: 11;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td:first-child) {
  position: sticky;
  left: 0;
  background: #f5f5f5 !important;
  z-index: 11;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 复选框列中的复选框层级 */
.optimized-table :deep(.ant-table-thead > tr > th:first-child .ant-checkbox-wrapper),
.optimized-table :deep(.ant-table-tbody > tr > td:first-child .ant-checkbox-wrapper) {
  position: relative;
  z-index: 13;
}

.optimized-table :deep(.ant-table-thead > tr > th:first-child .ant-checkbox),
.optimized-table :deep(.ant-table-tbody > tr > td:first-child .ant-checkbox) {
  position: relative;
  z-index: 13;
}

.optimized-table :deep(.ant-table-thead > tr > th:first-child .ant-checkbox-inner),
.optimized-table :deep(.ant-table-tbody > tr > td:first-child .ant-checkbox-inner) {
  position: relative;
  z-index: 13;
}

/* 照片预览样式 */
.photo-preview-container {
  position: relative;
}
.photo-preview-carousel-wrapper {
  position: relative;
}
.photo-preview-nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  border: none;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s;
}
.photo-preview-nav-button:hover:not(:disabled) {
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
}
.photo-preview-nav-button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
.photo-preview-nav-button.prev-button {
  left: 10px;
}
.photo-preview-nav-button.next-button {
  right: 10px;
}
.photo-preview-counter {
  text-align: center;
  margin-top: 10px;
  color: #666;
}
.photo-preview-slide {
  text-align: center;
}
.photo-preview-slide img {
  max-width: 100%;
  max-height: 480px;
  margin: 0 auto 16px;
  cursor: pointer;
  display: block;
}
</style>

<style>
/* 确认弹窗按钮样式 */
.ant-modal-confirm .ant-modal-confirm-btns .ant-btn {
  border-radius: 4px !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:hover:not(:disabled) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:focus:not(:disabled) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:active:not(:disabled) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-default {
  border-radius: 4px !important;
}
</style>
